function below_comments_widget()
{
    var widget = '<div id="M440576ScriptRootC385561"><div id="M440576PreloadC385561"> Loading... </div></div>';
    var target = 'div.article-body #comments-container';

    if($(target).length == 0){
        return; // this means the comments container doesnt exist, to avid errors
    }

    $(target).append(widget);

    var D=new Date(), d=document, b='body', ce='createElement', ac='appendChild',st='style',ds='display',n='none',gi='getElementById', lp=d.location.protocol, wp=lp.indexOf('http')==0?lp:'https:';
    var i=d[ce]('iframe'); i[st][ds]=n; d[gi]("M440576ScriptRootC385561")[ac](i);
    try{
        var iw=i.contentWindow.document; iw.open(); iw.writeln("<ht"+"ml><bo"+"dy></bo"+"dy></ht"+"ml>"); iw.close(); var c=iw[b];
    } catch(e){
        var iw=d; var c=d[gi]("M440576ScriptRootC385561");
    }

    var dv=iw[ce]('div'); dv.id="MG_ID"; dv[st][ds]=n; dv.innerHTML=385561; c[ac](dv); var s=iw[ce]('script'); s.async='async'; s.defer='defer'; s.charset='utf-8';
    s.src=wp+"//jsc.mgid.com/r/e/realclearscience.com.385561.js?t="+D.getYear()+D.getMonth()+D.getUTCDate()+D.getUTCHours();
    c[ac](s);
}

function init_widgets()
{
    below_comments_widget();
}

export default init_widgets;